function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#F05133",
  d: "M92.71 44.408L52.591 4.291a5.918 5.918 0 00-8.369 0l-8.33 8.332L46.459 23.19a7.022 7.022 0 017.229 1.685 7.03 7.03 0 011.67 7.275l10.186 10.185a7.028 7.028 0 017.275 1.671 7.043 7.043 0 01-9.961 9.958 7.043 7.043 0 01-1.531-7.658l-9.5-9.499v24.997a7.042 7.042 0 11-8.096 11.291 7.042 7.042 0 012.307-11.496v-25.23a7.041 7.041 0 01-3.823-9.235L31.798 16.715 4.288 44.222a5.92 5.92 0 000 8.371l40.121 40.118a5.918 5.918 0 008.369 0L92.71 52.779a5.92 5.92 0 000-8.371z"
});

function SvgGitRepoArtifact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97
  }, props), _ref);
}

export default __webpack_public_path__ + "git-repo-artifact.e17d9.svg";
export { SvgGitRepoArtifact as ReactComponent };